module.exports = __webpack_public_path__ + "static/media/Liz-Caunt.fa37d1cc.jpg";